module.exports = __webpack_public_path__ + "static/media/email.97a4ce3a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Support/icons/email.svg
// module id = 1518
// module chunks = 0